import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./retail.module.css";

export const Retail = ({ slice }) => {
  const { heading, copy } = slice?.primary || {};

  return (
    <section
      data-color-scheme="black"
      data-highlight-background="mellow-yellow"
      data-tilt-scheme="right"
    >
      <div className="section-split-6-5 page-width padding-section-vertical">
        <motion.div
          className={styles.copy}
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {heading && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h1">{children}</h2>,
              }}
            />
          )}
          {copy && <PrismicRichText field={copy.richText} />}
        </motion.div>
        <motion.div
          className={styles.retailers}
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.25, 0.1, 0.25, 1],
          }}
        >
          <ul className={styles.list}>
            {slice.items?.map(({ retailer_link, retailer_logo }, index) => (
              <motion.li
                key={retailer_logo.url}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.4,
                  delay: index * 0.1,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
              >
                {retailer_link?.url ? (
                  <a href={retailer_link.url} target="_blank" rel="noreferrer">
                    <GatsbyImage
                      image={retailer_logo.gatsbyImageData}
                      alt={retailer_logo.alt || ""}
                      objectFit="contain"
                      className={"company-logo " + styles.logo}
                    />
                  </a>
                ) : (
                  <GatsbyImage
                    image={retailer_logo.gatsbyImageData}
                    alt={retailer_logo.alt || ""}
                    objectFit="contain"
                    className={"company-logo " + styles.logo}
                  />
                )}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyRetail on PrismicHomepageDataBodyRetail {
    primary {
      heading {
        richText
      }
      copy {
        richText
      }
    }
    items {
      retailer_link {
        url
      }
      retailer_logo {
        gatsbyImageData(placeholder: BLURRED)
        url
        alt
      }
    }
  }
`;
